import { handleActions } from 'redux-actions';
import { post, get } from 'api/apiUtils';
import { APP_NAME } from 'config';
import { clearAuthToken } from '../../api/utilities/utilities';
import { saveToken } from './auth';

/* ---------- API URLS  ---------- */
const USER_URLS = {
  LOGIN_USER: '/login'
};

/* ---------- ACTIONS  ---------- */
const LOGIN = `${APP_NAME}/user/LOGIN`;
const LOGIN_SUCCESS = `${APP_NAME}/user/LOGIN_SUCCESS`;
const LOG_OUT = 'USER_LOGOUT';
const TEST_API = "TEST_API"

/* ---------- ACTION CREATORS ---------- */
export function login(username, password) {
  return async (dispatch) => {
    try {
      dispatch({ type: LOGIN, loading: true });
      const user = await post(USER_URLS.LOGIN_USER, {
        username,
        password
      });

      // Mock token
      let myToken = {
        accessToken: user.access,
        refreshToken: user.refresh,
        // 3 minutes
        accessExpires: new Date(new Date().getTime() + (60 * 60 * 1000)).getTime(),
        // 1 ish months
        refreshExpires: new Date(new Date().getTime() + (480 * 60 * 60 * 1000)).getTime()
      }

      dispatch(
        saveToken(myToken)
      )

      return dispatch({
        type: LOGIN_SUCCESS,
        loading: false,
        data: user,
        token: myToken
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };
};

export function logoutUser() {
  clearAuthToken();
  return (dispatch) => {
    dispatch(logout());
  };
}

export function logout() {
  return {
    type: LOG_OUT,
    loading: false,
    data: null
  }
};

export function testApi() {
  return (dispatch) => {
    // dispatch(
    // )
    get('http://google.com/login', {
      hey: 'there'
    })
  }
}

/* ---------- REDUCER ---------- */
const initialState = {
  loading: false,
  data: null
};

const handlers = {
  [LOGIN]: (state, action) => {
    return {
      ...state,
      loading: action.loading
    };
  },
  [LOGIN_SUCCESS]: (state, action) => {
    return {
      ...state,
      loading: action.loading,
      data: action.data,
    };
  },
  [LOG_OUT]: (state = initialState, action) => {
    return {
      ...state,
      loading: action.loading,
    }
  },
  [TEST_API]: (state, action) => {
    return {
      ...state
    }
  }
};

export default handleActions(handlers, initialState);


// WEBPACK FOOTER //
// ./src/redux-modules/modules/user.js